module.exports = __webpack_public_path__ + "static/media/22.1c6d40df.wav";